import { filter } from 'lodash';
import { defineStore } from 'pinia';
import axios from 'axios'; 

export const useToplinesStore = defineStore('Toplines', {
  state: () => ({
    toplineData: null,
    // 'polling' (default topline output) or 'non_polling'; set from the topline page toggle
    dataMode: 'polling',
  }),
  getters: {
  },
  actions: {
    setToplineData(data) {
      this.toplineData = data;
      // console.log(data);
    },
    setDataMode(mode) {
      this.dataMode = mode;
    },
  },
});